import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyBillsState } from '../reducers/my-bills.reducer';

export const selectMyBillsState = createFeatureSelector<MyBillsState>('myBills');

export const selectServices = createSelector(selectMyBillsState, state => state.services);

export const selectPayment = createSelector(selectMyBillsState, state => state.payment);

export const selectPaymentComponentByIdZap = (idZap?: string | null) =>
  createSelector(selectPayment, state => state?.components?.filter(v => v?.idZap === idZap)?.at(0) || null);

export const selectCalculation = createSelector(selectMyBillsState, state => state.calculation);

export const selectPayerData = (identSigId?: string | null) => createSelector(selectMyBillsState, state => state.services?.filter(v => v?.identSigid === identSigId)?.at(0) || null);

export const selectLoading = createSelector(selectMyBillsState, state => state.loading > 0);

export const selectPending = createSelector(selectMyBillsState, state => state.pending > 0);
